jQuery(document).ready(function ($) {
    $('.block--vf-process').each(function () {
        const $block = $(this);
        $(this).find('.info a').click(function (e) {
            e.preventDefault();
            $block.find('.desktop-video .yt-cover:visible').click();
        });
    });
});